<template>
  <div class="organdevice-bd bd" :class="{ 'crm-organdevice': !!orgId }">
    <div class="aside" :class="{ gray: userData.userId }">
      <div class="ub-f1 ubv" style="height: 100%">
        <div class="title">
          <i class="icon icon-zuzhi"></i>
          <span>{{ $t('base_organdevice.bu_men') }}</span>
        </div>
        <div class="search">
          <el-input style="width: 100%" @input="filterTree" :placeholder="$t('base_organdevice.bu_men_ming_cheng')" v-model="appKey" clearable></el-input>
        </div>
        <div class="tree" :style="`padding-bottom: ${this.screenH - this.position - 80}px;`">
          <el-tree
            ref="tree"
            node-key="bizId"
            :data="organTree"
            default-expand-all
            :props="{ label: 'bizName' }"
            :highlight-current="true"
            :expand-on-click-node="false"
            :default-expanded-keys="expandedKeys"
            @node-click="handleNodeClick"
            :filter-node-method="filterNode"
          >
            <span class="tree-item" slot-scope="{ node }">
              <span class="line1">{{ node.label }}</span>
            </span>
          </el-tree>
        </div>
      </div>
      <!-- 组织用户 -->
      <div class="aside-user ubv" :style="{ top: `${position + moveY - startY}px` }" :class="{ gray: !userData.userId }">
        <div class="bar" @mousedown="onmousedown">
          <div class="bar-box center">
            <div></div>
            <div></div>
          </div>
        </div>
        <div class="ub-f1 ubv" style="height: 0">
          <div class="title">
            <i style="font-size: 18px" class="icon icon-zuzhi1"></i>
            <span>{{ $t('base_organdevice.yuan_gong') }}</span>
          </div>
          <div class="search">
            <el-input style="width: 100%" @input="getOrganUser" :placeholder="$t('base_organdevice.yuan_gong_xing_ming')" v-model="userForm.search" clearable></el-input>
          </div>
          <div class="user-list ub-f1" style="height: 0; overflow-y: auto">
            <ul>
              <li
                :class="[{ cur: userData.userId === item.userId }, { auto: item.relationType === 1 }]"
                v-for="(item, index) in organUserList"
                :key="index"
                class="ub ub-sp ub-xc"
                @click="handleUserClick(item)"
              >
                <div class="name line1">{{ item.realName || item.userName }}</div>
                <!-- <template v-if="!isGroupOrgan">
                  <custom-select
                    :clearable="false"
                    v-model="item.relationType"
                    code="dms_user_device_relate_rule"
                    :placeholder="$t('com_please_select')"
                    width="100px"
                    value-type="number"
                    @change="relationTypeChange(index)"
                    :disabled="!(funcView.organ_device_change_way || !!orgId)"
                  ></custom-select>
                </template> -->
              </li>
            </ul>
          </div>
          <div style="padding: 12px 6px; text-align: center">
            <el-pagination
              small
              v-if="userTotal"
              layout="prev, pager, next"
              @current-change="onCurrentPage"
              :current-page="userForm.pageNum"
              :page-size="userForm.pageSize"
              :total="userTotal"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>
    <!-- 主要内容区域 -->
    <template v-if="showSection">
      <!-- 组织 -->
      <div class="section" v-if="`${organData.parentId}` === '0' && !userData.userId">
        <custom-tab v-model="currentTab" :list="tabs" style="margin: 0 -16px"></custom-tab>
        <organ-device-item :organ="organData" :orgId="orgId" :orgBy="orgBy" v-if="currentTab == 'tab1'"></organ-device-item>
        <organ-location-item :organ="organData" :orgId="orgId" :orgBy="orgBy" v-if="currentTab == 'tab2'"></organ-location-item>
      </div>
      <div class="section padding0 ubv" v-else>
        <!-- 用户-上部分 -->
        <template v-if="userData.userId">
          <div class="ub-f1" style="height: 0" v-if="funcView.depuser_device_assign">
            <organ-device-auto :orgId="orgId" :user="userData" @success="loadDevices"></organ-device-auto>
          </div>
        </template>
        <!-- 部门-上部门  -->
        <template v-else>
          <div class="ub-f1" style="height: 0" v-if="funcView.depuser_dep_location_list">
            <organ-location-auto :organ="organData" @success="loadDevices"></organ-location-auto>
          </div>
          <div style="height: 16px; background-color: #e4ebf2" v-if="funcView.depuser_dep_location_list && funcView.depuser_dep_device_list"></div>
        </template>
        <!-- 用户-下部分 -->
        <template v-if="userData.userId">
          <div style="height: 16px; background-color: #e4ebf2" v-if="funcView.depuser_device_assign && (funcView.depuser_device_list || funcView.depuser_loction_list)"></div>
          <div class="ub-f1 ubv" style="height: 0" v-if="funcView.depuser_device_list || funcView.depuser_loction_list">
            <custom-tab v-model="userCurrentTab" :list="userTabs"></custom-tab>
            <div class="ub-f1 ubv" style="padding: 0 16px; height: 0" key="tab2" v-if="userCurrentTab == 'tab1'">
              <organ-device-bind
                ref="tab1"
                class="ub-f1 ubv"
                :permission="{ add: funcView.depuser_user_add_device, del: funcView.depuser_user_remove_device }"
                style="height: 0"
                :organ="organData"
                :user="userData"
              ></organ-device-bind>
            </div>
            <div class="ub-f1 ubv" style="padding: 0 16px; height: 0" key="tab2" v-if="userCurrentTab == 'tab2'">
              <user-location ref="tab2" class="ub-f1 ubv" style="height: 0" vheight="100%" :userId="userData.bizId"></user-location>
            </div>
          </div>
        </template>
        <!-- 部门-下部门  -->
        <template v-else>
          <div class="ub-f1" style="height: 0; padding: 0 16px" v-if="funcView.depuser_dep_device_list">
            <organ-device-bind ref="tab" :permission="{ add: funcView.depuser_dep_add_device, del: funcView.depuser_dep_remove_device }" :organ="organData" :user="userData"></organ-device-bind>
          </div>
        </template>
      </div>
    </template>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import organDeviceAuto from './children/organ_device_auto.vue';
import organLocationAuto from './children/organ_location_auto.vue';
import organDeviceItem from './children/organ_device_item.vue';
import organLocationItem from './children/organ_location_item.vue';
import organDeviceBind from './children/organ_device_bind.vue';
import userLocation from '../user/children/user_location';

export default {
  components: { organDeviceAuto, organLocationAuto, organDeviceItem, organLocationItem, organDeviceBind, userLocation },
  name: 'organdevice',
  props: {
    orgId: [String, Number],
    orgBy: String,
  },
  data() {
    return {
      showSection: false,
      currentTab: 'tab1',
      userCurrentTab: 'tab1',
      userTabs: [],
      appKey: '',
      appKey1: '',
      organTree: [],
      organData: {},
      expandedKeys: ['1'],

      userForm: {
        search: '',
        bizId: '',
        bizType: '',
        orderBy: '',
        orderType: '',
        pageSize: 20,
        pageNum: 1,
      },
      userData: {},
      organUserList: [],
      userTotal: 0,

      position: 0,
      screenH: 0,
      startY: 0,
      moveY: 0,
    };
  },
  computed: {
    tabs() {
      return [
        {
          name: this.$t('base_organdevice.ji_qi'),
          value: 'tab1',
          code: 'tab1',
        },
        {
          name: this.$t('base_organdevice.xiang_mu'),
          value: 'tab2',
          code: 'tab2',
        },
      ];
    },
  },
  mounted() {
    this.reseruserForm = JSON.stringify(this.userForm);
    this.getOrganTree();
    this.getFuncView('/company/organdevice', () => {
      const list = [];
      let current = '';
      if (this.funcView.depuser_device_list) {
        list.push({
          name: this.$t('base_organdevice.ji_qi'),
          value: 'tab1',
          code: 'tab1',
        });
        current = 'tab1';
      }
      if (this.funcView.depuser_loction_list) {
        list.push({
          name: this.$t('base_organdevice.xiang_mu'),
          value: 'tab2',
          code: 'tab2',
        });
        current = current || 'tab2';
      }
      this.userTabs = list;
      this.userCurrentTab = current;
    });
    this.getDictionary('dms_user_device_relate_rule');
    this.screenH = document.body.clientHeight;
    this.position = (this.screenH * 3) / 5;
  },
  methods: {
    loadDevices() {
      this.$nextTick(() => {
        if (this.$refs.tab) {
          this.$refs.tab.onPageChange({ page: 1 });
        }
        if (this.$refs.tab1) {
          this.$refs.tab1.onPageChange({ page: 1 });
        }
        if (this.$refs.tab2) {
          this.$refs.tab2.onPageChange({ page: 1 });
        }
      });
    },
    // 获取组织树
    getOrganTree: function () {
      this.$getJSON(apis.DepartmentTree, { orgId: this.orgId }).then((res) => {
        this.organTree = [res.data];
        this.organData = res.data; // 选中第一项
        this.$nextTick(() => {
          this.$refs.tree.setCurrentKey(this.organData.bizId);
          this.showSection = true;
        });
      });
    },
    // 搜索过滤事件
    filterTree: function () {
      this.$refs.tree.filter(this.appKey);
    },
    // 搜索过滤
    filterNode: function (value, data) {
      if (!value) {
        return true;
      }
      return data.bizName.indexOf(value) !== -1;
    },
    // 选中组织
    handleNodeClick: function (data) {
      this.userForm = JSON.parse(this.reseruserForm);
      this.expandedKeys = [data.bizId];
      this.organData = data;
      this.userData = {};
      this.getOrganUser();
    },
    // 选中用户
    handleUserClick: function (data) {
      if (this.userData.userId === data.userId) {
        this.userData = {};
        return;
      }
      this.userData = data;
    },
    // 关联规则
    changeUserAuto: function (item, row) {
      let val = '';
      if (item !== undefined) {
        val = typeof item === 'object' ? item.value : item;
      }
      this.$postJSON(apis.DeviceAutoUser, {
        toBizId: this.organData.bizId,
        toBizType: this.organData.bizType,
        relationType: val,
        bizId: row.userId,
        bizType: '3',
      }).then(() => {
        this.$refs.tabs.onPageChange({ page: 1 });
      });
    },
    // 组织用户
    getOrganUser: function () {
      this.userForm.bizId = this.organData.bizId;
      this.userForm.bizType = this.organData.bizType;
      this.$getJSON(apis.DepartmentUserPage, this.userForm).then((res) => {
        this.organUserList = res.data.list;
        this.userTotal = res.data.total;
      });
    },
    // 组织用户切换页
    onCurrentPage: function (page) {
      this.userForm.pageNum = page;
      this.getOrganUser();
    },
    // 按下鼠标指针的x轴坐标
    onmousedown: function (event) {
      this.startY = event.clientY;
      this.moveY = event.clientY;
      window.addEventListener('mousemove', this.move);
      window.addEventListener('mouseup', this.stop);
    },
    // 鼠标移动处理函数
    move: function (event) {
      if (event.clientY < 200) {
        this.moveY = 200;
        return;
      }
      if (event.clientY > this.screenH - 200) {
        this.moveY = this.screenH - 200;
        return;
      }
      this.moveY = event.clientY;
    },
    // 松开鼠标处理函数
    stop: function () {
      this.position = this.position + this.moveY - this.startY;
      this.moveY = 0;
      this.startY = 0;
      window.removeEventListener('mousemove', this.move);
      window.removeEventListener('mouseup', this.stop);
      // 释放所有操作对象
    },
  },
};
</script>

<style lang="scss">
@import '@/style/mixin.scss';

.organdevice-bd {
  height: 100%;
  padding: 16px;
  position: relative;
  &.crm-organdevice {
    padding: 0;
  }
  & > .aside {
    position: absolute;
    box-shadow: 0.5px 0px 3px 0px rgba(51, 51, 51, 0.12);
    top: 0;
    left: 0;
    bottom: 0;
    width: 240px;
    display: flex;
    flex-direction: column;
    padding-bottom: 10px;
    background-color: #ffffff;
    overflow: auto;
    .title {
      padding: 0 10px;
      line-height: 70px;
      color: #394668;
      font-weight: bold;
      font-size: 15px;
      user-select: none;
      .icon {
        float: left;
        font-size: 14px;
        margin-right: 8px;
        font-weight: normal;
        @include color_main();
      }
    }
    .search {
      margin: 0 10px 16px;
    }
    .list {
      .el-tree-node__content > .el-tree-node__expand-icon {
        display: none;
      }
      .el-tree-node__content .tree-item {
        padding-left: 10px;
      }
    }
    .list,
    .tree {
      flex: 1;
      margin: 0 10px;
      overflow-y: auto;
      .el-tree-node__content {
        line-height: 32px;
        height: 32px;
        &:hover {
          background-color: #f8f9fb;
        }
      }
      .el-tree-node__content > .el-tree-node__expand-icon {
        color: #495057;
        &.is-leaf {
          color: transparent;
        }
      }
      .is-current > .el-tree-node__content {
        background-color: #eef2f8 !important;
        .tree-item {
          @include color_main();
          .icon {
            @include color_main();
            font-size: 12px;
          }
          .disable {
            color: rgba(108, 117, 125, 0.5);
          }
        }
      }
      .tree-item {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 12px;
        padding-right: 10px;
        overflow: hidden;
        color: #6c757d;
        .disable {
          color: rgba(108, 117, 125, 0.5);
        }
      }
    }
  }
  & > .section {
    height: 100%;
    margin-left: 240px;
    display: flex;
    flex-direction: column;
    background-color: #ffffff;
    padding: 0 16px;
    &.padding0 {
      padding: 0;
    }
    .section-info {
      padding-top: 16px;
      table {
        width: 100%;
      }
      table tr {
        height: 44px;
        line-height: 44px;
        text-align: left;
        th {
          padding: 0 10px;
          font-size: 12px;
          color: #636e78;
          background-color: #f2f3fb;
        }
        td {
          padding: 0 10px;
          color: #6c757d;
          font-size: 12px;
          border-bottom: 1px solid #eef2f8;
        }
      }
    }
    .table-bd {
      flex: 1;
      height: 0;
    }
  }

  .aside {
    &.gray {
      background-color: #f8f9fb !important;
    }
    .el-tree {
      background-color: transparent;
      .line1 {
        font-size: 12.5px;
      }
    }
    .bar {
      cursor: ns-resize;
      position: relative;
      height: 10px;
      text-align: center;
      @include background_color_main();
      .bar-box {
        width: 16px;
        div {
          height: 1px;
          background-color: rgba(255, 255, 255, 0.66);
        }
        div:first-child {
          margin-bottom: 2.5px;
        }
      }
    }
    .aside-user {
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      background-color: #ffffff;
      &.gray {
        background-color: #f8f9fb;
      }
      .user-list {
        padding: 0 14px;
        ul > li {
          cursor: pointer;
          height: 40px;
          padding-right: 7px;
          &.cur {
            background-color: #eef2f8;
            .name {
              @include color-main();
            }
          }
          &.auto .el-input__inner {
            color: #879cbb;
            border: 1px solid rgba(222, 226, 230, 1);
          }
          .el-input__inner {
            color: #495057;
          }
          .name {
            color: #6c757d;
            font-size: 12px;
            padding-left: 10px;
            line-height: 40px;
          }
        }
      }

      .el-pagination {
        button,
        .number {
          background-color: transparent !important;
        }
      }
    }
  }
}
</style>
